import Immutable from 'seamless-immutable'

const R = require('ramda');

// is this object already Immutable?
const isImmutable = R.has('asMutable')

// change this Immutable object into a JS object
const convertToJs = (state) => state.asMutable({ deep: true })

// optionally convert this object into a JS object if it is Immutable
const fromImmutable = R.when(isImmutable, convertToJs)

// convert this JS object into an Immutable object
const toImmutable = (raw) => Immutable(raw)

// redux-persist invokes transforms per reducer key with that key's slice — not the root state.
const resetTransientFlags = (state, key) => {
    if (!state) {
        return state;
    }

    // In-flight request flags must not survive rehydration or persist across sessions.
    if (key === 'businessCustomers' || key === 'paymentTracks' || key === 'paymentSchedules') {
        const nextState = { ...state };
        Object.keys(nextState).forEach((flag) => {
            if (typeof nextState[flag] === 'boolean' && nextState[flag] === true && /^(fetching|updating|applying)/.test(flag)) {
                nextState[flag] = false;
            }
        });
        if (key === 'businessCustomers') {
            nextState.applyingBatchNos = [];
            nextState.applying = false;
        }
        return nextState;
    }

    // switching:true can be written after SWITCH_MEMBERSHIP_REQUEST and race past
    // persistor.purge(); if it rehydrates, the topbar spinner spins forever.
    if (key === 'defMembership') {
        return {
            ...state,
            switching: false,
            fetching: false,
            updating: false,
        };
    }

    return state;
};

// the transform interface that redux-persist is expecting
const stateTransformers = {
    out: (state, key) => {
        return toImmutable(resetTransientFlags(fromImmutable(state), key));
    },
    in: (raw, key) => {
        return fromImmutable(resetTransientFlags(raw, key));
    }
};

export default stateTransformers;
